import { all, fork } from 'redux-saga/effects';

import listenLoad from './listenLoad';

export default function* staticPageSaga() {
  yield all([fork(listenLoad)]);
}
